import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { H1 } from '@expo/html-elements';
import { theme, TitleText, useResponsive } from '@sg/garnish';

export const SweetpassCheckoutHeader = ({ children }: ViewProps) => {
  const { currentBreakpoint } = useResponsive();
  const { match, minWidth } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const headingStyles = [
    styles.heading,
    minWidth.isSM ? styles.headingSM : undefined,
    { color: currentBreakpoint.isXS ? undefined : theme.colors.LIME },
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={match([styles.headerMobile, styles.headerTabletUp])}>
      <H1 style={headingStyles}>
        <TitleText size={match([3, 4])} style={headingStyles}>
          {children}
        </TitleText>
      </H1>
    </View>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerMobile: {
    paddingBottom: theme.spacing['10'],
  },
  headerTabletUp: {
    paddingVertical: theme.spacing['10'],
  },
  heading: {
    marginVertical: 0,
  },
  headingSM: {
    textAlign: 'center',
    marginVertical: 0,
  },
});
